import React, { Fragment } from "react";
import { DragInfo } from "./baseTypes";

const Red = ({ onMouseDown, onTouchStart }) => {
  return (
    <div
      className="command paint paint-red"
      onMouseDown={evt =>
        onMouseDown({ x: evt.clientX, y: evt.clientY }, "paint-red")
      }
      onTouchStart={evt => {
        evt.preventDefault();
        const touch = evt.touches[0];
        onTouchStart({ x: touch.clientX, y: touch.clientY }, "paint-red", "", touch);
      }}
    />
  );
};
const Green = ({ onMouseDown, onTouchStart }) => {
  return (
    <div
      className="command paint paint-green"
      onMouseDown={evt =>
        onMouseDown({ x: evt.clientX, y: evt.clientY }, "paint-green")
      }
      onTouchStart={evt => {
        evt.preventDefault();
        const touch = evt.touches[0];
        onTouchStart({ x: touch.clientX, y: touch.clientY }, "paint-green", "", touch);
      }}
    />
  );
};
const Blue = ({ onMouseDown, onTouchStart }) => {
  return (
    <div
      className="command paint paint-blue"
      onMouseDown={evt =>
        onMouseDown({ x: evt.clientX, y: evt.clientY }, "paint-blue")
      }
      onTouchStart={evt => {
        evt.preventDefault();
        const touch = evt.touches[0];
        onTouchStart({ x: touch.clientX, y: touch.clientY }, "paint-blue", "", touch);
      }}
    />
  );
};


interface ColorCommandsProps {
  colors: number,
  onMouseDown: any,
  onTouchStart: any,
}


const ColorCommands = ({ colors, onMouseDown, onTouchStart }: ColorCommandsProps) => {
  if (colors === 1) {
    return (
      <Fragment>
        <Red onMouseDown={onMouseDown} onTouchStart={onTouchStart} />
        <div className="divider" />
      </Fragment>
    );
  }
  if (colors === 2) {
    return (
      <Fragment>
        <Green onMouseDown={onMouseDown} onTouchStart={onTouchStart} />
        <div className="divider" />
      </Fragment>
    );
  }
  if (colors === 3) {
    return (
      <Fragment>
        <Red onMouseDown={onMouseDown} onTouchStart={onTouchStart} />
        <Green onMouseDown={onMouseDown} onTouchStart={onTouchStart} />
        <div className="divider" />
      </Fragment>
    );
  }
  if (colors === 4) {
    return (
      <Fragment>
        <Blue onMouseDown={onMouseDown} onTouchStart={onTouchStart} /> <div className="divider" />
      </Fragment>
    );
  }
  if (colors === 5) {
    return (
      <Fragment>
        <Red onMouseDown={onMouseDown} onTouchStart={onTouchStart} />
        <Blue onMouseDown={onMouseDown} onTouchStart={onTouchStart} /> <div className="divider" />
      </Fragment>
    );
  }
  if (colors === 6) {
    return (
      <Fragment>
        <Green onMouseDown={onMouseDown} onTouchStart={onTouchStart} />
        <Blue onMouseDown={onMouseDown} onTouchStart={onTouchStart} /> <div className="divider" />
      </Fragment>
    );
  }
  if (colors === 7) {
    return (
      <Fragment>
        <Red onMouseDown={onMouseDown} onTouchStart={onTouchStart} />
        <Green onMouseDown={onMouseDown} onTouchStart={onTouchStart} />
        <Blue onMouseDown={onMouseDown} onTouchStart={onTouchStart} /> <div className="divider" />
      </Fragment>
    );
  }
  return null;
};


interface CommandsProps {
  SubLengths: number[],
  AllowedCommands: number,
  dragging: DragInfo | null,
  onMouseDown: any,
  onTouchStart: any,
}


const Commands = ({ SubLengths, AllowedCommands, dragging, onMouseDown, onTouchStart }: CommandsProps) => {
  return (
    <div className={`commands-area ${dragging ? "dragging" : ""}`}>
      <div
        className="command forward"
        onMouseDown={evt =>
          onMouseDown({ x: evt.clientX, y: evt.clientY }, "forward", "")
        }
        onTouchStart={evt => {
          evt.preventDefault();
          const touch = evt.touches[0];
          onTouchStart({ x: touch.clientX, y: touch.clientY }, "forward", "", touch);
        }}
      />
      <div
        className="command left"
        onMouseDown={evt =>
          onMouseDown({ x: evt.clientX, y: evt.clientY }, "left", "")
        }
        onTouchStart={evt => {
          evt.preventDefault();
          const touch = evt.touches[0];
          onTouchStart({ x: touch.clientX, y: touch.clientY }, "left", "", touch);
        }}
      />
      <div
        className="command right"
        onMouseDown={evt =>
          onMouseDown({ x: evt.clientX, y: evt.clientY }, "right", "")
        }
        onTouchStart={evt => {
          evt.preventDefault();
          const touch = evt.touches[0];
          onTouchStart({ x: touch.clientX, y: touch.clientY }, "right", "", touch);
        }}
      />
      <div className="divider" />
      {SubLengths.map(
        (s, i) =>
          s > 0 && (
            <div
              key={`sublength-${i}`}
              className={`command f${i}`}
              onMouseDown={evt =>
                onMouseDown({ x: evt.clientX, y: evt.clientY }, `f${i}`)
              }
              onTouchStart={evt => {
                evt.preventDefault();
                const touch = evt.touches[0];
                onTouchStart({ x: touch.clientX, y: touch.clientY }, `f${i}`, "", touch);
              }}
            />
          )
      )}
      <div className="divider" />
      <ColorCommands
        colors={AllowedCommands}
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
      />
      <div
        className="command color clear"
        onMouseDown={evt =>
          onMouseDown({ x: evt.clientX, y: evt.clientY }, null, "clear")
        }
        onTouchStart={evt => {
          evt.preventDefault();
          const touch = evt.touches[0];
          onTouchStart({ x: touch.clientX, y: touch.clientY }, null, "clear", touch);
        }}
      />
      <div
        className="command color red"
        onMouseDown={evt =>
          onMouseDown({ x: evt.clientX, y: evt.clientY }, null, "red")
        }
        onTouchStart={evt => {
          evt.preventDefault();
          const touch = evt.touches[0];
          onTouchStart({ x: touch.clientX, y: touch.clientY }, null, "red", touch);
        }}
      />
      <div
        className="command color green"
        onMouseDown={evt =>
          onMouseDown({ x: evt.clientX, y: evt.clientY }, null, "green")
        }
        onTouchStart={evt => {
          evt.preventDefault();
          const touch = evt.touches[0];
          onTouchStart({ x: touch.clientX, y: touch.clientY }, null, "green", touch);
        }}
      />
      <div
        className="command color blue"
        onMouseDown={evt =>
          onMouseDown({ x: evt.clientX, y: evt.clientY }, null, "blue")
        }
        onTouchStart={evt => {
          evt.preventDefault();
          const touch = evt.touches[0];
          onTouchStart({ x: touch.clientX, y: touch.clientY }, null, "blue", touch);
        }}
      />
    </div>
  );
};

export default Commands;
